import { useState, useEffect, useRef } from 'react';
import Menu from './Menu';
import SubMenu from './Sub_menu';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import api from '../service/api';
import '../css/Avaliacao.css';

// Anamneses
import AnamneseAdulto from './anamneses/AnamneseAdulto.js';
import AnamneseMulheresEmagrecimento from './anamneses/AnamneseMulheresEmagrecimento.js';
import AnamneseIdosos from './anamneses/AnamneseIdosos.js';
import AnamneseGestantes from './anamneses/AnamneseGestantes.js';
import AnamneseDepressao from './anamneses/AnamneseDepressao.js';
import AnamneseDiabetes from './anamneses/AnamneseDiabetes.js';
import AnamneseHipertensao from './anamneses/AnamneseHipertensao.js';
import AnamneseObesos from './anamneses/AnamneseObesos.js';
import AnamnesePosParto from './anamneses/AnamnesePosParto.js';

// Específicos dos idosos
import CapFuncionalQuest from './idosos/CapacidadeFuncionalQuestionario';
import TesteCapFunc from './idosos/TesteCapacidadeFuncional.js';
import AntropometriaIdosos from './idosos/Antropometria.js'
import EscalaBeg from './idosos/Escala_berg.js';
import Katz from './idosos/Katz.js';
import Lawton from './idosos/Lawton.js';

// Gerais
import Antropometria from './avaliacoes/AntropometriaGeral.js';
import ParQ from './avaliacoes/ParQ.js';
import Coronariano from './avaliacoes/Coronariano.js';
import ComposicaoCorporal from './avaliacoes/ComposicaoCorporal.js';
import Vo2 from './avaliacoes/Vo2.js';
import PrescricaoTreinoAerobico from './avaliacoes/PrescricaoTreinoAerobico.js';
import AvaliacaoNeuromuscular from './avaliacoes/AvaliacaoNeuromuscular.js';
import PrescricaoTreinoForca from './avaliacoes/PrescricaoTreinoForca.js';

function Avaliacao() {
    const [activeTab, setActiveTab] = useState("Anamnese");
    const location = useLocation();
    const navigate = useNavigate();

    const { id: urlId } = useParams();
    const [evaluationId, setEvaluationId] = useState(urlId || location.state?.evaluationId || undefined);
    const [evaluationData, setEvaluationData] = useState(null);

    const aluno = location.state?.alunoSelecionado;
    const { idade = "", name = "", profile = "", id = "", sexo = "" } = aluno || {};

    const PROFILE_TO_ANAMNESE = {
        homensEMulheresAdultos: 'anamneseAdultos',
        mulheresQueDesejamEmagrecer: 'anamneseEmagrecimento',
        idosos: 'anamneseIdosos',
        gestantes: 'anamneseGestantes',
        posParto: 'anamnesePosParto',
        obesos: 'anamneseObesos',
        diabetesMelitus: 'anamneseDiabetes',
        hipertensaoArterial: 'anamneseHipertensao',
        depressao: 'anamneseDepressao',
    };

    const [perfilAnamnese, setPerfilAnamnese] = useState(
        PROFILE_TO_ANAMNESE[aluno?.profile] || 'anamneseAdultos'
    );

    const hasFetchedInitialData = useRef(false);

    useEffect(() => {
        fetchEvaluation();
    }, [evaluationId, aluno?.id]);

    useEffect(() => {
        if (!location.state?.alunoSelecionado) {
            navigate("/home");
        }
    }, [location, navigate]);

    if (!location.state?.alunoSelecionado) {
        return null;
    }

    async function fetchEvaluation() {
        const isInitialLoad = !hasFetchedInitialData.current && !!(urlId || location.state?.evaluationId);
        if (isInitialLoad && evaluationId && aluno?.id) {
            try {
                const response = await api.get(`/api/student/${aluno.id}/evaluation/${evaluationId}`, { withCredentials: true });
                setEvaluationData(response.data);
            } catch (error) {
                console.error("Erro ao buscar dados da avaliação", error);
            } finally {
                hasFetchedInitialData.current = true;
            }
        }
    };

    function updateEvaluationData(newData) {
        setEvaluationData(prev => ({ ...prev, ...newData }));
    }

    const renderTabContent = () => {
        switch (activeTab) {
            case "Anamnese":
                switch (perfilAnamnese) {
                    case "anamneseAdultos":
                        return <AnamneseAdulto setActiveTab={setActiveTab} aluno={aluno} setEvaluationId={setEvaluationId} evaluationId={evaluationId} setPerfilAnamnese={setPerfilAnamnese} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;
                    case "anamneseEmagrecimento":
                        return <AnamneseMulheresEmagrecimento setActiveTab={setActiveTab} aluno={aluno} setEvaluationId={setEvaluationId} evaluationId={evaluationId} setPerfilAnamnese={setPerfilAnamnese} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;
                    case "anamneseIdosos":
                        return <AnamneseIdosos setActiveTab={setActiveTab} aluno={aluno} setEvaluationId={setEvaluationId} evaluationId={evaluationId} setPerfilAnamnese={setPerfilAnamnese} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;
                    case "anamneseGestantes":
                        return <AnamneseGestantes setActiveTab={setActiveTab} aluno={aluno} setEvaluationId={setEvaluationId} evaluationId={evaluationId} setPerfilAnamnese={setPerfilAnamnese} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;
                    case "anamnesePosParto":
                        return <AnamnesePosParto setActiveTab={setActiveTab} aluno={aluno} setEvaluationId={setEvaluationId} evaluationId={evaluationId} setPerfilAnamnese={setPerfilAnamnese} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;
                    case "anamneseObesos":
                        return <AnamneseObesos setActiveTab={setActiveTab} aluno={aluno} setEvaluationId={setEvaluationId} evaluationId={evaluationId} setPerfilAnamnese={setPerfilAnamnese} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;
                    case "anamneseDiabetes":
                        return <AnamneseDiabetes setActiveTab={setActiveTab} aluno={aluno} setEvaluationId={setEvaluationId} evaluationId={evaluationId} setPerfilAnamnese={setPerfilAnamnese} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;
                    case "anamneseHipertensao":
                        return <AnamneseHipertensao setActiveTab={setActiveTab} aluno={aluno} setEvaluationId={setEvaluationId} evaluationId={evaluationId} setPerfilAnamnese={setPerfilAnamnese} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;
                    case "anamneseDepressao":
                        return <AnamneseDepressao setActiveTab={setActiveTab} aluno={aluno} setEvaluationId={setEvaluationId} evaluationId={evaluationId} setPerfilAnamnese={setPerfilAnamnese} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;
                    default:
                        return <AnamneseAdulto setActiveTab={setActiveTab} aluno={aluno} setEvaluationId={setEvaluationId} evaluationId={evaluationId} setPerfilAnamnese={setPerfilAnamnese} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;
                }

            case "ParQ":
                return <ParQ setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            case "Coronariano":
                return <Coronariano setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            case "Antropometria":
                return <Antropometria setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            case "Composicao Corporal":
                return <ComposicaoCorporal setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            case "Vo2":
                return <Vo2 setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            case "PrescricaoTreinoAerobico":
                return <PrescricaoTreinoAerobico setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            case "AvaliacaoNeuromuscular":
                return <AvaliacaoNeuromuscular setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            case "PrescricaoTreinoForca":
                return <PrescricaoTreinoForca setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            // 🔽 IDOSOS
            case "CapFuncionalQuest":
                return <CapFuncionalQuest setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;
            
            case "TesteCapFunc":
                return <TesteCapFunc setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            case "AntropometriaIdosos":
                return <Antropometria setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;
                //Por enquanto vamos usar a antropometria comum return <AntropometriaIdosos setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            case "EscalaBeg":
                return <EscalaBeg setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            case "Katz":
                return <Katz setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            case "Lawton":
                return <Lawton setActiveTab={setActiveTab} aluno={aluno} evaluationId={evaluationId} setEvaluationId={setEvaluationId} evaluationData={evaluationData} updateEvaluationData={updateEvaluationData} />;

            default:
                return null;
        }
    };

    return (
        <div>
            <Menu isAvaliacao={true} nome={name} idade={idade} perfil={profile} aluno={aluno} dataAvaliacao={evaluationData?.evaluationDate || new Date().toISOString()} />
            <SubMenu activeTab={activeTab} onTabChange={setActiveTab} aluno={aluno} />
            {renderTabContent()}
        </div>
    );
}

export default Avaliacao;